interface PaginationProps {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    onChange: (page: number) => void;
}

const Pagination = ({
    page,
    limit,
    total,
    totalPages,
    onChange
}: PaginationProps) => {
    if (total === 0) return null;

    const start = (page - 1) * limit + 1;
    const end = Math.min(page * limit, total);
    return (
        <div className="flex items-center justify-between px-4 py-3 border-t dark:border-zinc-800 bg-white dark:bg-zinc-900">
            {/* Left text */}
            <p className="text-sm text-indigo-600 dark:text-indigo-400">
                Showing <span className="font-medium">{start}</span> to{' '}
                <span className="font-medium">{end}</span> of{' '}
                <span className="font-medium">{total}</span> results
            </p>

            {/* Buttons */}
            <div className="flex gap-2">
                <button
                    disabled={page <= 1}
                    onClick={() => onChange(page - 1)}
                    className={`w-9 h-9 flex items-center justify-center rounded-md border transition
    ${page <= 1
                            ? 'opacity-40 cursor-not-allowed'
                            : 'hover:bg-zinc-900 '
                        }`}
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className={`${page <= 1 ? 'text-gray-400' : 'text-white'}`}
                    >
                        <polyline points="15 18 9 12 15 6" />
                    </svg>
                </button>

                <button
                    disabled={page >= totalPages}
                    onClick={() => onChange(page + 1)}
                    className={`w-9 h-9 flex items-center justify-center rounded-md border transition
    ${page >= totalPages
                            ? 'opacity-40 cursor-not-allowed'
                            : 'hover:bg-zinc-900 '
                        }`}
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className={`${page >= totalPages ? 'text-gray-400' : 'text-white '}`}
                    >
                        <polyline points="9 18 15 12 9 6" />
                    </svg>
                </button>

            </div>
        </div>
    );
};

export default Pagination;
